import type { ReactElement } from 'react'
import React from 'react'

import { caption } from '@ui-kit/core/typography'

import RadioCard from './RadioCard/index.web'
import * as styles from './styles'
import type { RadioOptionValue, WebProps } from './types'

const RadioCardSet = (props: WebProps): ReactElement => {
  const layout = props.layout ?? 'compact'

  const onOptionClick = (newValue: RadioOptionValue) => {
    if (newValue === props.value) {
      return
    }

    if (typeof props.onValueChange === 'function') {
      props.onValueChange(newValue)
    }
  }

  const hasTopTags = props.options.some((option) => option.topTag !== undefined)
  const hasBottomTags = props.options.some((option) => option.bottomTag !== undefined)
  const options = props.options.filter((option) => !option.hidden)
  const { container, list } = styles.radioCardSet({
    hasTopTags,
    hasBottomTags,
    layout,
  })

  return (
    <div className={container()}>
      <div className={list()}>
        {options.map((option) => (
          <RadioCard
            {...option}
            hasBottomTags={hasBottomTags}
            hasTopTags={hasTopTags}
            onClick={onOptionClick}
            key={String(option.value)}
            layout={option.layout ?? layout}
            isSelected={option.value === props.value}
            isUntouched={props.value === undefined}
            disabled={option.disabled || props.disabled || false}
            testID={`radio-card-${option.value}`}
          />
        ))}
      </div>
      {props.errorMessage && <p className={caption({ color: 'error' })}>{props.errorMessage}</p>}
    </div>
  )
}

export default RadioCardSet
